<template>
    <router-link
        :to="route"
        v-if="helper.permissionCheckOverRouteList([[route.name, helper.getNestedValue('params.tab', route)]])"
        class="menu-dropdown dropdown-orange-item px-2 rounded-md py-2 flex items-center"
      >
        <span class="text-sm text-white">{{ $t(`message.${label}`) }}</span>
    </router-link>
</template>




<script>

import helper from "Resources/util/helper";




export default {
    name: "SideMenuItem",

    props: {
        route: {
            default: null,
            type: Object,
            requried: true
        },
        label: {
            default: '',
            type: String,
            requried: true
        },
        
    },

    data() {
        return {
            helper,
        };
    },

    components: {
      
    }
}
</script>